import { Bell, BellRing } from "lucide-react";
import { TooltipIconButton } from "@/components/trading/TooltipIconButton";
import { useAlertSubscriptions } from "@/preferences/useAlertSubscriptions";
import { cn } from "@/lib/utils";

/** Per-material signal-flip email opt-in. PRO+ feature: locked tiers see
 * a disabled bell with an upgrade hint. State is shared with the
 * Preferences page via useAlertSubscriptions. Disabled while the
 * subscription set loads (also covers the billing-undefined window —
 * a free user's fetch 402s into locked, so an unlocked flash can't
 * show a usable bell). Rapid double-clicks are two sequential
 * toggles — last intent wins; no debounce needed at this scale. */
export function AlertBellToggle({ materialId }: { materialId: string }) {
  const { subscribed, locked, loading, toggle } = useAlertSubscriptions();
  const isOn = subscribed.has(materialId);

  const label = locked
    ? "Signal alerts are a PRO feature"
    : isOn
      ? `Alerts on for ${materialId} — click to turn off`
      : `Email me when ${materialId} flips`;

  return (
    <TooltipIconButton
      label={label}
      ariaPressed={isOn}
      disabled={locked || loading}
      onClick={() => void toggle(materialId)}
      // shrink-0: the pane header is a min-w-0 flex row; without this the
      // bell shrinks before MaterialPicker's min-width floor kicks in.
      className="flex-shrink-0"
    >
      {isOn ? (
        <BellRing className="h-4 w-4 text-primary" />
      ) : (
        <Bell className={cn("h-4 w-4", locked && "opacity-40")} />
      )}
    </TooltipIconButton>
  );
}
